import { render } from "./Admin.Tests.DoubleCheckBadge.vue?vue&type=template&id=d01f6cae&scoped=true"
import script from "./Admin.Tests.DoubleCheckBadge.vue?vue&type=script&lang=js"
export * from "./Admin.Tests.DoubleCheckBadge.vue?vue&type=script&lang=js"

import "./Admin.Tests.DoubleCheckBadge.vue?vue&type=style&index=0&id=d01f6cae&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01f6cae"]])

export default __exports__